export default __webpack_public_path__ + "static/media/6.3e1acd3f.svg";